export const capitalizeEveryWord = (str = "") => {
  return str.replace(/\b\w/g, function (char) {
    return char.toUpperCase();
  });
};

export const parseDate = (timestamp) => {
  const date = new Date(timestamp.$date);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export function sortByProperty(array, propertyName) {
  return array.sort((a, b) => {
    if (a[propertyName] < b[propertyName]) {
      return -1;
    }
    if (a[propertyName] > b[propertyName]) {
      return 1;
    }
    return 0;
  });
}

const EXCEPTIONS = new Set(['it', 'ai', 'hr', 'ux', 'grc']);

export function denormalizeString(str) {
    return str
      .split('_')
      .map(word => (EXCEPTIONS.has(word) ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1)))
      .join(' ');
}


export function parseAndDenormalize(data, fields){
    const jsonData = JSON.parse(data);
    jsonData.forEach(item => {
      fields.forEach(field => {
        if (item[field]) {
          item[field] = denormalizeString(item[field]);
        }
      })
    });
    return jsonData;
}

export const shuffle = (array) => { 
  for (let i = array.length - 1; i > 0; i--) { 
    const j = Math.floor(Math.random() * (i + 1)); 
    [array[i], array[j]] = [array[j], array[i]]; 
  } 
  return array; 
}; 

export const localizeVar = (obj, key, lang = "en") => {
  return obj[`${key}_${lang}`]         // Try requested language
      || obj[`${key}_en`]              // Fallback to English
      || null;                         // Nothing found
}

export function getCompanyDisplayName(item, currLang, dict) {
  const key = localizeVar(item, "company_name", currLang);
  return currLang === "en"
    ? dict[key] || key // fallback if not in dict
    : denormalizeString(key);
}

export function forceLtrRange(str, lang) {
  if (lang !== 'ar') return str;

  // Flip numeric ranges like "0-2"
  let flipped = str.replace(/(\d+)-(\d+)/g, (_, start, end) => `${end}-${start}`);

  // Flip numbers with trailing '+'
  flipped = flipped.replace(/(\d+)\+/g, (_, num) => `${num}+`);

  return flipped;
}